<script>
  import { createEventDispatcher } from 'svelte';

  export let isOpen = true;
  // export let deviceId;
  
  const dispatch = createEventDispatcher();

  const topMenuItems = [
    { name: 'Home',      page: 'dashboard',    icon: 'bi-house-fill' },
    { name: 'New Order', page: 'order',        icon: 'bi-kanban' },
    { name: 'Management',page: 'database',     icon: 'bi-file-earmark-bar-graph' },
    { name: 'Download',  page: 'download',     icon: 'bi-cloud-arrow-down' },
    { name: 'Photo',     page: 'machinephoto', icon: 'bi-image', hasDropdown: true },
    { name: 'Login',     page: 'login',        icon: 'bi-person-fill-add' }
  ];

  // 하단 메뉴
  const bottomMenuItems = [
    { name: 'Operator', page: 'operatorpage', icon: 'bi-collection' }
  ];

  let showPhotoDropdown = false;
  const machines = Array.from({ length: 10 }, (_, i) => String(i + 1).padStart(2, '0'));

  const toggleSidebar = () => {
    isOpen = !isOpen;
    showPhotoDropdown = false;
  };

  const go = (item) => {
    if (item.hasDropdown) {
      showPhotoDropdown = !showPhotoDropdown;
    } else {
      dispatch('navigate', item.page);
      showPhotoDropdown = false;
    }
  };

  const selectMachine = (id) => {
    dispatch('navigate', `machinephoto?device=${id}`);
    showPhotoDropdown = false;
  };
</script>

<aside class:is-open={isOpen}>
  <button class="sidebar-header" on:click={toggleSidebar}>
    <i class="bi bi-list menu-icon"></i>
    {#if isOpen}<span class="menu-title">MENU</span>{/if}
  </button>

  <nav class="sidebar-nav">
    <ul>
      {#each topMenuItems as item}
        <li>
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a href="#"
             on:click|preventDefault={() => go(item)}
             class:has-dropdown={item.hasDropdown}>
            <i class="bi {item.icon}"></i>
            {#if isOpen}<span class="menu-text">{item.name}</span>{/if}
            {#if item.hasDropdown && isOpen}
              <i class="bi {showPhotoDropdown ? 'bi-caret-down' : 'bi-caret-right'} dropdown-icon"></i>
            {/if}
          </a>

          {#if item.hasDropdown && showPhotoDropdown}
            <ul class="submenu">
              {#each machines as m}
                <li>
                  <!-- svelte-ignore a11y-invalid-attribute -->
                  <a href="#"
                     on:click|preventDefault={() => selectMachine(m)}>
                    {isOpen ? `Machine ${m}` : m}
                  </a>
                </li>
              {/each}
            </ul>
          {/if}
        </li>
      {/each}

      <!-- 하단 메뉴도 동일 루프 구조 -->
      <!-- {#each bottomMenuItems as item}
        <li>
          <a href="#"
             on:click|preventDefault={() => go(item)}>
            <i class="bi {item.icon}"></i>
            {#if isOpen}<span class="menu-text">{item.name}</span>{/if}
          </a>
        </li>
      {/each} -->
    </ul>
  </nav>
</aside>

<style>
  aside {
    position: fixed;
    top: 60px;
    left: 0;
    height: calc(100vh - 60px);
    background-color: #f8f9fa;
    color: #212529;
    overflow-y: auto;
    transition: width 0.3s ease;
    z-index: 1000;
    width: 220px;
  }
  aside:not(.is-open) { width: 70px; }

  .sidebar-header {
    all: unset;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.6rem 1rem;
    cursor: pointer;
    width: 100%;
  }
  .menu-icon { font-size: 1.5rem; color: #212529; }
  .menu-title { font-size: 1.1rem; font-weight: bold; white-space: nowrap; }
  .sidebar-nav { padding: 0 0.5rem 1rem; white-space: nowrap; }
  .sidebar-nav ul { list-style: none; padding: 0; margin: 0; }
  .sidebar-nav li { margin: 0.5rem 0; }
  .sidebar-nav a {
    color: #212529;
    text-decoration: none;
    padding: 0.4rem 0.6rem;
    display: flex;
    align-items: center;
    border-radius: 4px;
    gap: 0.6rem;
    font-size: 15px;
  }
  aside.is-open .sidebar-nav a { font-size: 22px; }
  .sidebar-nav a:hover { background-color: #e2e6ea; }
  .sidebar-nav i { font-size: 1.2rem; min-width: 20px; text-align: center; }
  .dropdown-icon { margin-left: auto; font-size: 1rem; }

  .submenu { list-style: none; margin: 0.3rem 0 0.3rem 1.5rem; padding: 0; }
  .submenu li { margin: 0.2rem 0; }
  .submenu a { padding: 0.4rem 0.4rem; font-size: 0.75rem !important; display: block; }
  .submenu a:hover { background-color: #e2e6ea; }

  @media (max-width: 768px) {
    aside { width: 70px; }
    aside.is-open { width: 220px; }
  }
</style>